export default {"src":"/_next/static/media/instagram.60b31ff8.svg","height":40,"width":40};